import type { ChatEntry, ToolCallProps, ToolCallUpdatedPayload } from '@/types'

export function appendAssistantText(entries: ChatEntry[], content: string): ChatEntry[] {
  const updated = [...entries]
  const last = updated[updated.length - 1]
  if (last?.role !== 'assistant') return updated

  const segments = [...last.segments]
  const lastSeg = segments[segments.length - 1]

  if (lastSeg?.type === 'text') {
    segments[segments.length - 1] = { ...lastSeg, content: lastSeg.content + content }
  } else {
    segments.push({ type: 'text', content })
  }

  updated[updated.length - 1] = { ...last, segments }
  return updated
}

export function appendAssistantToolCall(entries: ChatEntry[], toolCall: ToolCallProps): ChatEntry[] {
  const updated = [...entries]
  const last = updated[updated.length - 1]
  if (last?.role !== 'assistant') return updated

  const segments = [...last.segments]
  const lastSeg = segments[segments.length - 1]

  if (lastSeg?.type === 'tool_calls') {
    segments[segments.length - 1] = { ...lastSeg, calls: [...lastSeg.calls, toolCall] }
  } else {
    segments.push({ type: 'tool_calls', calls: [toolCall] })
  }

  updated[updated.length - 1] = { ...last, segments }
  return updated
}

export function patchToolCallResult(entries: ChatEntry[], payload: ToolCallUpdatedPayload): ChatEntry[] {
  let changed = false

  const updatedEntries = entries.map((entry) => {
    if (entry.role !== 'assistant') return entry

    let entryChanged = false
    const segments = entry.segments.map((segment) => {
      if (segment.type !== 'tool_calls') return segment

      let segmentChanged = false
      const calls = segment.calls.map((call) => {
        if (call.tool_call_id !== payload.tool_call_id) return call

        segmentChanged = true
        return { ...call, result: payload.result }
      })

      if (!segmentChanged) return segment

      entryChanged = true
      return { ...segment, calls }
    })

    if (!entryChanged) return entry

    changed = true
    return { ...entry, segments }
  })

  return changed ? updatedEntries : entries
}
